import * as React from 'react';
import { cn } from '@/utils/utils';

interface ChoiceProps {
  /** The Checkbox, Switch or RadioGroupItem; clicking the words toggles it too. */
  control: React.ReactNode;
  label: React.ReactNode;
  /** A line under the label. */
  description?: React.ReactNode;
  /** start: the control before its words (a checkbox or radio in a form); end: the words, then the control at the row's end (a setting's switch). */
  layout?: 'start' | 'end';
  className?: string;
}

/** A checkbox, switch or radio with its words, the whole row its label. */
export function Choice({ control, label, description, layout = 'start', className }: ChoiceProps) {
  const words = (
    <span className="flex min-w-0 flex-col gap-0.5">
      <span className="leading-[1.3]">{label}</span>
      {description && <span className="text-lureo-12 leading-[1.4] text-lureo-ink-subtle">{description}</span>}
    </span>
  );
  return (
    <label
      className={cn(
        'flex cursor-pointer items-center gap-2 font-lureo-font-ui text-lureo-13 text-lureo-ink has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-lureo-disabled-opacity',
        layout === 'end' && 'justify-between gap-3',
        className,
      )}
    >
      {layout === 'start' ? (
        <>
          <span className="inline-flex shrink-0">{control}</span>
          {words}
        </>
      ) : (
        <>
          {words}
          <span className="inline-flex shrink-0">{control}</span>
        </>
      )}
    </label>
  );
}
